const options = {
  5: "bg-yellow-50/5",
  10: "bg-yellow-50/10",
  25: "bg-yellow-50/25",
  50: "bg-yellow-50/50",
  75: "bg-yellow-50/75",
  90: "bg-yellow-50/90",
  100: "bg-yellow-50",
};

const from = {
  5: "from-yellow-50/5",
  10: "from-yellow-50/10",
  25: "from-yellow-50/25",
  50: "from-yellow-50/50",
  75: "from-yellow-50/75",
  90: "from-yellow-50/90",
  100: "from-yellow-50",
};

export default function getBackgroundYellow50(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
